import React from 'react';
import { HTMLMotionProps, motion } from 'motion/react';

import { cn } from '@components/primitives/utilities';

import transitions from '@utils/transitions';

import { CardSection } from './CardSection';

import styles from './Card.module.css';

const variants = {
  initial: { y: 32, opacity: 0 },
  enter: { y: 0, opacity: 1, transition: transitions.spring },
  exit: { y: -24, opacity: 0, transition: transitions.spring },
};

type AnimatedCardProps = HTMLMotionProps<'div'> & {
  transparent?: boolean;
  variant?: string;
};

export function AnimatedCard({
  children,
  className,
  variant,
  transparent = false,
  ...props
}: AnimatedCardProps) {
  return (
    <motion.div
      className={cn(!transparent && styles.card, className)}
      variants={variants}
      data-variant={variant}
      {...props}
    >
      {children}
    </motion.div>
  );
}

AnimatedCard.Section = CardSection;
